/* eslint-disable indent */
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import middlewarePipeline from './middlewarepipeline'

// routes
import Login from '@/components/pages/login/routes.login'
import Locations from '@/components/pages/locations'
// import LocationGroup from '@/components/pages/locationGroups'
import Signage from '@/components/pages/signageDevices/signageDevices'
import DeviceSummary from '@/components/pages/deviceSummary'
import Reports from '@/components/pages/reports/reports'

// 404 Page
import PageNotFound from '@/components/pages/PageNotFound'

import { auth } from '@/router/middlewares/auth'

/* Global Components */
/* -----Offset Heading----- */
import OffsetHeading from '@/components/custom-components/OffsetHeading'
Vue.component('offset-heading', OffsetHeading)
Vue.component('offset-block', () => import('@/components/custom-components/OffsetBlock'))
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [...Login,
  // {
  //   path: '/',
  //   redirect: '/locations'
  // },
  {
    path: '/locations',
    component: Locations,
    name: 'Locations',
    meta: {
      middleware: [auth],
      nav: {
        display: true,
        name: 'Locations'
      }
    }
  },
  // {
  //   path: '/locations-groups',
  //   component: LocationGroup,
  //   name: 'Location Groups',
  //   meta: {
  //     middleware: [auth],
  //     nav: {
  //       display: true,
  //       name: 'Location Groups'
  //     }
  //   }
  // },
  {
    path: '/signage-devices',
    component: Signage,
    name: 'Signage Devices',
    meta: {
      middleware: [auth],
      nav: {
        display: true,
        name: 'Signage Devices'
      }
    }
  },
  {
    path: '/device-summary',
    component: DeviceSummary,
    name: 'Device Summary',
    meta: {
      middleware: [auth],
      nav: {
        display: true,
        name: 'Device Summary'
      }
    }
  },
  // {
  //   path: '/reports',
  //   component: Reports,
  //   name: 'Reports',
  //   meta: {
  //     middleware: [auth],
  //     nav: {
  //       display: true,
  //       name: 'Reports'
  //     }
  //   }
  // },
  {
    path: '*',
    component: PageNotFound,
    name: 'Page Not Found',
    meta: {
      middleware: [auth],
      nav: {
        display: false,
        name: 'Page Not Found'
      }
    }
  }

  ]
})

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware || to.meta.middleware.length <= 0) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

export default router
